import { useMemo, useState } from "react";
import Aside from "../../components/Aside";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import { ReportService } from "../../services/ReportsService";
import { ChannelUtil } from "../../utils/channel";
import { DateUtil } from "../../utils/date";
import { MessageUtil } from "../../utils/message";
import { AlertService } from "../../services/Alert";

function FollowUpPage() {

    const [ticket, setTicket] = useState(null)
    const [customer, setCustomer] = useState(null)
    const [conversations, setConversations] = useState([])


    const initialsCustomer = useMemo(() => {
        if (!ticket?.name_client) return;

        return ticket.name_client[0].toUpperCase()
    }, [ticket])
    
    const downloadDocument = async (url) => {
        await AlertService.warning('Descargar archivo', '¿Te gustaría realizar la descarga de este archivo?', async () => {
            try {
                window.open(url, '_blank');
            } catch (error) {
                console.error(error);
                AlertService.error('¡Error!', 'Ocurrió un error al descargar el archivo, intenta nuevamente')
            }
        });
    }
    
    return (
        <>
            <Header />
            <Aside />

            <main id="content" role="main" className="main">

                <div className="content container-fluid">

                    <div className="page-header">
                        <div className="row align-items-center">
                            <div className="col-sm mb-2 mb-sm-0">
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb breadcrumb-no-gutter">
                                        <li className="breadcrumb-item "><span className="breadcrumb-link" >Operación</span></li>
                                        <li className="breadcrumb-item active" aria-current="page">Monitoreo</li>
                                    </ol>
                                </nav>
                                <h1 className="page-header-title"><i className="bi-chat-left-dots"></i> Monitoreo</h1>
                            </div>
                            <div className="col-sm-auto">
                                
                            </div>
                        </div>
                    </div>

                    <div>
                        <div className="row g-0 h-100">
                            <div className="col-3 h-100 border">

                            </div>
                            <div className="col-6 h-100">
                                <div className="bg-light border h-100 d-flex flex-column">

                                    <div className="bg-white border-bottom shadow-sm p-3">
                                        <div className="d-flex align-items-center">


                                            <span className="avatar avatar-primary avatar-circle">
                                                <span className="avatar-initials">{initialsCustomer}</span>
                                            </span>
                                            <div className="ms-2 ">
                                                <h4 className="mb-0">{ticket?.name_client}</h4>
                                                <p className="m-0 form-text">{ticket?.numero_entrada?.slice(0, -5)}</p>
                                            </div>

                                            <div className="ms-auto">

                                                <button className="btn bg-soft-primary btn-sm  border">
                                                    <i className="bi-download"></i> Descargar mensajes
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="p-3 flex-grow-1 d-flex flex-column-reverse overflow-scroll" >

                                        {
                                            conversations.map((conversation) => (
                                                <div className="d-flex mb-5 " key={conversation.id}>
                                                    <div className={`chat-message-content ${conversation.sendBy === 'Client' && conversation.nameSend === 'Client' ? 'received' : ''}`}>
                                                        <div className={`received-message-content m-w rounded-1 p-3 ${conversation.sendBy === 'Client' && conversation.nameSend === 'Client' ? 'border' : 'ms-auto'}`}>
                                                            {conversation.sendBy === 'Agent' && conversation.nameSend !== 'Client' && <div><h6 className="text-white m-0">{conversation.nameSend}</h6></div>}
                                                            {conversation.sendBy === 'Agent' && conversation.nameSend === 'Client' && <div><h6 className="text-white m-0">🤖 Bot</h6></div>}

                                                            <div className={`${conversation.sendBy === 'Client' && conversation.nameSend === 'Client' ? 'mb-3' : 'my-3'}`}  >
                                                                {conversation.type === 'txt' && <div dangerouslySetInnerHTML={{ __html: MessageUtil.format(conversation.message) }} />}

                                                                {conversation.type === 'image' && (
                                                                    <>
                                                                        <div className="preview-img" onClick={() => downloadDocument(ReportService.getURLExternalFile(conversation.ticketID, conversation.message))} style={{ backgroundImage: `url(${ReportService.getURLExternalFile(conversation.ticketID, conversation.message)})` }}></div>
                                                                        {conversation.caption && <p className="m-0 mt-2">conversation.caption</p>}
                                                                    </>
                                                                )}

                                                                {conversation.type === 'video' && (
                                                                    <>
                                                                        <div className="preview-video" ><video controls><source src={ReportService.getURLExternalFile(conversation.ticketID, conversation.message)} /></video></div>
                                                                        {conversation.caption && <p className="m-0 mt-2">conversation.caption</p>}
                                                                    </>
                                                                )}

                                                                {conversation.type === 'audio' && (
                                                                    <div className="preview-audio d-flex align-items-center" >
                                                                        <span className="avatar avatar-primary avatar-circle me-2">
                                                                            <span className="avatar-initials">{initialsCustomer}</span>
                                                                        </span>
                                                                        <audio controls><source src={ReportService.getURLExternalFile(conversation.ticketID, conversation.message)} /></audio>
                                                                    </div>
                                                                )}

                                                                {conversation.type === 'location' && <div className="" ><iframe width="250" height="250" loading="lazy" allowFullScreen src={ReportService.getURLLocation(conversation.lat, conversation.lng)} frameBorder={0} /></div>}

                                                                {conversation.type === 'document' && (
                                                                    <div className="d-flex align-items-center preview-document" onClick={() => downloadDocument(ReportService.getURLExternalFile(conversation.ticketID, conversation.message))}>
                                                                        <div className="category-icon"><i className="bi-paperclip"></i></div>
                                                                        <div className="ms-2">
                                                                            {conversation.message}
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </div>


                                                            <div><p className="m-0 small italic">{ChannelUtil.format(conversation.app)}</p></div>
                                                        </div>
                                                        <p className={`form-text mt-1 ${conversation.sendBy === 'Client' && conversation.nameSend === 'Client' ? '' : 'text-end'}`}>{DateUtil.format(conversation.date)}</p>
                                                    </div>
                                                </div>
                                            ))
                                        }
                                    </div>

                                    <div className="bg-white border-top shadow-sm p-3">
                                        <div className="text-center">
                                            <p className="h5">No puedes enviar mensajes en esta conversación</p>
                                            <p className="small">Una vez que un ticket ha sido cerrado, no es posible enviar mensajes. Si necesitas enviar un mensaje, por favor genera una nueva conversación reabriendo el ticket.</p>

                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div className="col-3 h-100 border">
                                <div className="text-center h-100 overflow-scroll">

                                    <div className="pt-5 bg-white ticket-info-header border-bottom">

                                        <div>
                                            <span className="avatar avatar-xl avatar-primary avatar-circle">
                                                <span className="avatar-initials">{initialsCustomer}</span>
                                            </span>
                                        </div>
                                        <h3 className="mt-3">{ticket?.name_client}</h3>
                                        <p className="form-text m-0"><i className="bi-telephone me-1"></i> {ticket?.numero_entrada?.slice(0, -5)}</p>

                                        <div className="d-flex justify-content-center my-5">

                                            <div>
                                                <button className="btn bg-soft-primary icon icon-circle mb-2 " >
                                                    {customer?.blocked ? <i className="bi-lock"></i> : <i className="bi-unlock"></i>}
                                                </button>
                                                <p className="form-text m-0">{customer?.blocked ? 'Desbloquear' : 'Bloquear'}</p>
                                            </div>

                                            <div className="ms-3">
                                                <button className="btn bg-soft-primary icon icon-circle mb-2" >
                                                    <i className="bi-pencil"></i>
                                                </button>
                                                <p className="form-text m-0">Editar</p>
                                            </div>

                                        </div>
                                    </div>

                                    <div className="mt-3">

                                        <div className="p-3 text-start">

                                            

                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>


                    

                    
                </div>
                <Footer />
            </main>

        </>
    )
}
export default FollowUpPage